/**
 * Floating labels in .form-dark-bg rely on :placeholder-shown to know when a
 * field is empty. An input with no placeholder attribute never matches
 * :placeholder-shown, so the label would float up immediately. Give such
 * fields an invisible placeholder (a single space) so the resting (centered)
 * label state works whether or not the editor set a placeholder in Formie.
 */
function ensureDarkFormPlaceholders() {
  document
    .querySelectorAll(
      ".form-dark-bg input.fui-input, .form-dark-bg textarea.fui-input"
    )
    .forEach((el) => {
      if (!el.hasAttribute("placeholder")) {
        el.setAttribute("placeholder", " ");
      }
    });
}

document.addEventListener("DOMContentLoaded", ensureDarkFormPlaceholders);
